import { StyleSheet } from 'react-native';

import { LAYOUT, THEME } from '../../reactor/common';

const { UNIT } = THEME;
const AVATAR_SIZE = UNIT * 2.8;

export default StyleSheet.create({
  avatar: {
    borderRadius: AVATAR_SIZE / 2,
    height: AVATAR_SIZE,
    width: AVATAR_SIZE,
  },

  container: {
    ...LAYOUT.STYLE.ROW,
    overflow: 'hidden',
  },

  content: {
    marginLeft: UNIT,
  },
});
